import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../core/theme/styled';
import { Caption } from '../../atoms/Text/Text';
import angle from './angle.svg';

export const Details = styled.details`
  summary {
    cursor: pointer;
    list-style: none;

    * {
      margin-left: 6px;
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.configuration.primaryColor, 0.25)};
    }

    &:before {
      content: '';
      background-repeat: no-repeat;
      background-image: url(${angle});
      background-position: 50%;
      background-size: contain;
      display: inline-block;
      width: 12px;
      height: 10px;
    }

    &::-webkit-details-marker {
      display: none;
    }
  }

  &[open] summary:before {
    transform: rotate(90deg);
  }
`;

export const DetailsBody = styled(Box)`
  background-color: ${({ theme }) => theme.configuration.tintedBackgroundColor};
`;

export const DetailsSection = styled.div`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.sizes.normal};
  }
`;

export const StyledParagraph = styled(Caption)`
  & + & {
    margin-top: 1rem;
  }

  & a {
    font-size: inherit;
    color: ${({ theme }) => theme.configuration.primaryColor};
    text-decoration: none;
  }

  & button {
    cursor: pointer;
    text-decoration: none;
    background-color: transparent;
    border: none;
    min-width: auto;
    min-height: auto;
    padding: 0;
    font-size: inherit;
    color: ${({ theme }) => theme.configuration.primaryColor};

    &:hover {
      color: ${({ theme }) => theme.configuration.primaryTextColor};
    }
  }
`;

export const DT = styled(Caption).attrs({ as: 'dt', bold: true })`
  &:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.sizes.normal};
  }
`;

export const DD = styled(Caption).attrs({ as: 'dd', monospace: true })`
  overflow-wrap: break-word;
`;
